import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-3 px-4 min-w-[640px] max-w-2xl" }
const _hoisted_2 = { class: "list-disc pl-3" }
const _hoisted_3 = { class: "text-sm text-justify" }
const _hoisted_4 = { class: "text-sm list-[circle] pl-4" }
const _hoisted_5 = ["onClick"]

import { ref } from "vue";
import { Location } from "@/keyboard";
import { useKeyboardStore, useHighlightStore } from "@/stores";
import PopupButton from "@/components/utils/PopupButton.vue";
import ConfigWarningsIndicator from "@/components/config/ConfigWarningsIndicator.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigWarnings',
  props: {
    indicatorClass: {}
  },
  setup(__props: any) {

const kb = useKeyboardStore();
const hl = useHighlightStore();



const highlightOn = ref(false);

const showLocation = (loc: Location) => {
  kb.setLayer(loc.layer);

  const duration = 1000; // ms
  hl.setHighlightedLayer(loc.layer, duration);
  hl.setHighlightedKey(loc.row, loc.column, duration);

  highlightOn.value = true;
  setTimeout(() => (highlightOn.value = false), duration);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupButton, {
    placement: 'bottom',
    offset: 3,
    class: _normalizeClass(["config-warnings", highlightOn.value ? 'config-warnings-hide' : ''])
  }, {
    button: _withCtx(() => [
      _createVNode(ConfigWarningsIndicator, {
        class: _normalizeClass(["animate-pulse hover:animate-none px-2", _ctx.indicatorClass ?? ''])
      }, null, 8, ["class"])
    ]),
    popup: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(kb).warnings, (warning, id) => {
            return (_openBlock(), _createElementBlock("li", {
              key: id,
              class: "pb-1"
            }, [
              _createTextVNode(_toDisplayString(warning.short) + " ", 1),
              _createElementVNode("p", _hoisted_3, _toDisplayString(warning.long), 1),
              _createElementVNode("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(warning.locations, (loc, locid) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: locid,
                    class: "link",
                    onClick: ($event: any) => (showLocation(loc))
                  }, " At layer " + _toDisplayString(loc.layer) + ", row " + _toDisplayString(loc.row) + ", column " + _toDisplayString(loc.column), 9, _hoisted_5))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})